import { Task, TaskInterface, TaskTemplateInterface } from 'app/task/models';

import { TaskActions, TaskActionType } from './actions';
import { TaskState, TaskStateInterface } from './models';

const initialState: TaskState = new TaskState({
  ids: [],
  tasks: {},
  selectedTask: undefined,
  currentTask: undefined,
  taskTemplates: undefined,
});

export function taskReducer(state: TaskStateInterface = initialState, action: TaskActions): TaskStateInterface {
  switch (action.type) {

    case TaskActionType.LoadTaskTemplatesCompleted:
      return {
        ...state,
        taskTemplates: action.payload as TaskTemplateInterface[],
      };

    case TaskActionType.CreateSurveyTask:
      return {
        ...state,
        currentTask: undefined,
      };

    case TaskActionType.CreateTaskCompleted:
      const newTask: TaskInterface = action.payload as TaskInterface;

      return {
        ...state,
        ids: [...state.ids, ...[newTask.id]],
        currentTask: action.payload as TaskInterface,
        tasks: {
          ...state.tasks, ...{ [newTask.id]: new Task(newTask) },
        },
      };

    case TaskActionType.LoadTasksCompleted:
      const allTasks: TaskInterface[] = action.payload as TaskInterface[];
      const newTasks: TaskInterface[] = allTasks.filter((task: TaskInterface) => !state.tasks[task.id]);
      const newTaskIds: number[] = newTasks.map((task: TaskInterface) => task.id);
      const newTaskEntities: { [id: number]: TaskInterface } = newTasks.reduce(
        (tasks: { [id: number]: TaskInterface }, task: TaskInterface) => {
          return { ...tasks, ...{
            [task.id]: new Task(task),
          }};
        },
        {});

      return {
        ...state,
        ids: newTaskIds,
        tasks: { ...state.tasks, ...newTaskEntities },
      };

    case TaskActionType.CloseTaskCompleted:
    case TaskActionType.UpdateTaskCompleted:
      const task: TaskInterface = action.payload as TaskInterface;
      const updatedTasks: { [id: number]: TaskInterface } = { ...state.tasks };
      updatedTasks[task.id] = new Task(task);

      return {
        ...state,
        tasks: updatedTasks,
      };

    case TaskActionType.SelectTaskCompleted:
      return {
        ...state,
        selectedTask: action.payload as number,
      };

    // TODO: Handle failures appropriately. This block makes downstream effects fail.
    case TaskActionType.CreateTaskFailed:
    case TaskActionType.CloseTaskFailed:
    case TaskActionType.LoadTaskTemplatesFailed:
    case TaskActionType.LoadTasksFailed:
    case TaskActionType.UpdateTaskFailed:
      return state;

    default:
      return state;
  }
}
